export default "__VITE_ASSET__9zLvR6dI__"